import React from 'react';
import { useTranslation } from 'react-i18next';
import Info from './Info';

function CommandItem({ command, value, description, type = 'text', onAdd, readonly, placeholder }) {
    const { t } = useTranslation();

    return (
        <tr>

            <th >
                <Info description={t(description)} />
                <div>{command}</div>
            </th>
            <td
            >
                <button onClick={() => {
                    onAdd(command, type, value, readonly, placeholder);
                }}><i className="fas fa-plus"></i></button>
            </td>

        </tr>
    );
}

export default CommandItem;
